export function formatString(string: string | string[]) {
  return Array.isArray(string) ? string.join(',') : string
}

export function prepareParams<T extends Record<string, any>>(params: T): Partial<T> {
  return (Object.keys(params) as Array<keyof T>).reduce((result, key) => {
    const value = params[key]

    if (value !== null && value !== undefined && value !== '') {
      result[key] = value
    }

    return result
  }, {} as Partial<T>)
}
